import { filter } from 'lodash/fp';
import r from '../Replacement';

class PageTitle {
    activeTitle = document.title;

    getActiveTitle = () => this.activeTitle;

    setPageTitle = title => {
        const docTitle = filter(x => x, [title, r('header.companyName')]).join(' - ');
        document.title = docTitle;
        this.activeTitle = title;
    };
}

export const pageTitleService = new PageTitle();
